module.exports = __webpack_public_path__ + "img/logo_portrait.99d12fd9.png";